<template>
  <b-row>
    <b-col cols="12" sm="6">
      <WidgetWrapperV2 
        :title="$t('dashboard.title.totalFleetTaskExpense')"
        :loading="isLoading"
        ref="widgetWrapper"
      >
        <template #afterTitle>
          <TransactionRangeDate :period.sync="period" />
        </template>
        <template #subTitle>
          <p class="mb-0">
            {{ momentDateShortMonth(period?.[0]) }} -
            {{ momentDateShortMonth(period?.[1]) }}
          </p>
        </template>
        <ExpenseByActivity :period="period" />
      </WidgetWrapperV2>
    </b-col>
    <b-col cols="12" sm="6">
      <WidgetWrapperV2 
        :title="$t('dashboard.title.totalFleetTaskExpense')"
        :loading="isLoading"
        ref="widgetWrapper"
      >
        <template #afterTitle>
          <div class="mc-period-type">
            <multiselect
              v-model="selectedPeriodType"
              :options="periodType"
              :multiple="false"
              placeholder="Select one"
              label="label"
            />
          </div>
        </template>
        <template #subTitle>
          <p class="mb-0">
            {{ subTitle }}
          </p>
        </template>
        <ExpenseByPeriod :periodType="selectedPeriodType.key" />
      </WidgetWrapperV2>
    </b-col>
  </b-row>
</template>
<script>
import moment from 'moment'
import { Helper } from '@/mixin/helper'
import ExpenseByActivity from '../components/TotalExpenseByActivity.vue'
import ExpenseByPeriod from '../components/TotalExpenseByPeriod.vue'
import WidgetWrapperV2 from '../components/WidgetWrapperV2.vue'
import TransactionRangeDate from '../components/TransactionRangeDate.vue'
import Multiselect from 'vue-multiselect'
export default {
  components: {
    ExpenseByActivity,
    WidgetWrapperV2,
    TransactionRangeDate,
    ExpenseByPeriod,
    Multiselect
  },
  mixins: [Helper],
  data() {
    return {
      isLoading: false,
      period: [moment().subtract(6, 'd').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
      selectedPeriodType: { key: 'DAILY', label: this.$t('dashboard.text.costPeriod.last7Days') },
    }
  },
  computed: {
    subTitle() {
      let start = moment().subtract(6, 'd').format('DD MMM YYYY')
      let end = moment().format('DD MMM YYYY')

      if (this.selectedPeriodType.key === 'WEEKLY') {
        start = `W${moment().subtract(6, 'w').week()}`
        end = `W${moment().week()}`
      }

      if (this.selectedPeriodType.key === 'MONTHLY') {
        start = moment().subtract(11, 'months').format('MMM YYYY')
        end = moment().format('MMM YYYY')
      }

      return `${start} - ${end}`
    },
    periodType() {
      return [
        { key: 'DAILY', label: this.$t('dashboard.text.costPeriod.last7Days') },
        { key: 'WEEKLY', label: this.$t('dashboard.text.costPeriod.last7Weeks') },
        { key: 'MONTHLY', label: this.$t('dashboard.text.costPeriod.last12Months') }
      ]
    },
  },
  watch: {
    periodType: function (newPeriodType) {
      const newSelected = newPeriodType.find(pt => pt.key === this.selectedPeriodType.key)
      if (!newSelected) return

      this.selectedPeriodType = newSelected
    },
  }
}
</script>
<style lang="scss" scoped>
.mc-period-type {
  width: 200px;
}
</style>